export default {
  createTitle: 'Centrum hozzáadása',
  updateTitle: 'Centrum Módosítása',

  action: {
    viewEvents: 'Események megtekintése',
    viewDoctors: 'Orvosok megtekintése',
    viewPatients: 'Páciensek megtekintése',
    addDoctors: 'Orvos hozzáadása',
    addPatients: 'Páciens hozzáadása',
  },

  fields: {
    name: 'Centrum neve',
    onDutyPhone: 'Ügyeleti telefonszám',
    address: 'Levelezési cím',
    email: "E-mail",
  }
}